import { Menu } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";

const ContextMenuWrapper = ({
    children,
    targetRef,
    className,
    specificPosition,
    setStateSelectedElement,
}: {
    children?: ReactNode;
    targetRef?: React.RefObject<HTMLElement>;
    className?: string;
    specificPosition?: { top?: number; left?: number };
    setStateSelectedElement?: (state: boolean) => void;
}) => {
    const [anchorPosition, setAnchorPosition] = useState<null | { top: number; left: number }>(null);

    useEffect(() => {
        const handleContextMenu = (event: Event) => {
            event.preventDefault();

            const mouseEvent = event as MouseEvent;
            setStateSelectedElement && setStateSelectedElement(true);
            setAnchorPosition({ top: mouseEvent.clientY, left: mouseEvent.clientX });
        };

        const targetElement = targetRef?.current || document;

        targetElement.addEventListener("contextmenu", handleContextMenu);
        document.addEventListener("mousedown", handleClose);

        return () => {
            targetElement.removeEventListener("contextmenu", handleContextMenu);
            document.removeEventListener("mousedown", handleClose);
        };
    }, [targetRef]);

    const handleClose = () => {
        setStateSelectedElement && setStateSelectedElement(false);

        setAnchorPosition(null);
    };

    if (!children) {
        return null;
    }

    return (
        <Menu
            open={Boolean(anchorPosition)}
            onClose={handleClose}
            style={{ boxShadow: "none !important" }}
            slotProps={{ paper: { className: className } }}
            anchorReference="anchorPosition"
            anchorPosition={{
                top: specificPosition?.top || anchorPosition?.top || 0,
                left: specificPosition?.left || anchorPosition?.left || 0
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left"
            }}
        >
            {children}
        </Menu>
    );
};

export default ContextMenuWrapper;
